export reportList from './reportList';
export sampleList from './sampleList';
export reportDetail from './reportDetail';
export sampleListNew from './sampleListNew';
export report from './report';
export lifeReport from './lifeReport';
export life from './life';
export lifeBank from './lifeBank';
export patchReport from './patchItemData';
export medicalReport from './medicalExamRreport';
export nutrition from './nutrition';


// WEBPACK FOOTER //
// ./src/reducers/index.js